<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.supplier">
    <div class="banner center" style="max-width:1000px;">
        <div class="row row_header freeze_height" style="border: none;">
            <div class="col-12" style="text-align: right;">
                <label style="font-weight: normal; margin-left: 30px;">
                    <input type="checkbox" [(ngModel)]="isShowInActive" (change)="onLoad()" />
                    <span class="normal_color">{{localService.languageContent.supplier.show_inactive}}</span>
                </label>
            </div>
        </div>
        <div class="row row_header freeze_height">
            <div class="col-2">
                {{localService.languageContent.table.action}}
            </div>
            <div class="col-6">
                {{localService.languageContent.table.title}}
            </div>
            <div class="col-4">
                {{localService.languageContent.table.created_on}}
                <div class="icon_action_header">
                    <button class="button_icon button_icon_color" (click)="onAction(1)">
                        note_add
                    </button>
                </div>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div *ngIf="(source && source.items.length > 0)" class="item-found">
                <div class="row styled_row" *ngFor="let item of source.items">
                    <div class="col-2">
                        <button class="button_icon"
                            title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                            (click)="onActiveInactiveStatus(item.key)"
                            [ngStyle]="{'color': item.v4 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v4 == '1' ?
                            "toggle_on" : "toggle_off"}}</button>
                    </div>
                    <div class="col-6">
                        <button class="button_icon button_icon_color" (click)="onAction(1,item.key)">
                            edit
                        </button>
                        <span class="en" *ngIf="item.v1">{{item.v1}}&nbsp;-&nbsp;</span>
                        <span [ngClass]="localService.getLanguageCode(item.v6)">
                            {{item.v5}}
                        </span>
                    </div>
                    <div class="col-4">
                        {{item.v7 | localDate}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="source && source.paging" [paging]="source.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<div>
    <app-supplier [(isOpenPopup)]="isOpenSupplier" [businessId]="businessId" [id]="selectedSupplierId"
        (onClose)="onLoad()" />
</div>